import PropTypes from 'prop-types';
import React, {Component} from 'react';
import {FmlxTextBox, FmlxLabel} from 'fmlx-common-ui';
import ReactHelper from '../../lib/reactHelper';

class PasswordShowHide extends Component {
  constructor(props) {
    super(props);

    this.state = {
      hidden: true,
    };

    this.toggleShow = this.toggleShow.bind(this);
  }

  shouldComponentUpdate(nextProps, nextState) {
    const arrProps = [
      'hidden',
      'labelHeader',
      'alertMessageContent',
      'placeholder',
      'value',
      'disabled',
      'onInputKeyPressed',
    ];

    return ReactHelper.basicShouldComponentUpdate(this.props, this.state, nextProps, nextState, arrProps);
  }

  toggleShow = () => {
    const {hidden} = this.state;

    this.setState({hidden: !hidden});
  };

  getLabelHeader = () => {
    const {labelHeader, required} = this.props;
    let header = '';

    if (labelHeader !== '') {
      header = (
        <label className="control-label" htmlFor={labelHeader}>
          {labelHeader}
          {required && <span style={{color: 'red'}}>*</span>}
        </label>
      );
    }

    return header;
  };

  // eslint-disable-next-line class-methods-use-this
  handlePreventSubmit = (e) => {
    e.preventDefault();
  };

  render() {
    const {placeholder, value, onChange, disabled, alertMessageContent, id, onInputKeyPressed} = this.props;

    return (
      <>
        <FmlxLabel label={this.getLabelHeader()} />
        <form className="inner-addon right-addon" autoComplete="off" onSubmit={(e) => this.handlePreventSubmit(e)}>
          <FmlxTextBox
            id={id}
            mode="password"
            error={alertMessageContent !== ''}
            placeholder={placeholder}
            value={value || ''}
            onChange={onChange}
            disabled={disabled}
            inlineText={alertMessageContent}
            onEnterKeyPressed={onInputKeyPressed}
          />
        </form>
      </>
    );
  }
}

PasswordShowHide.propTypes = {
  id: PropTypes.string.isRequired,
  labelHeader: PropTypes.string,
  required: PropTypes.bool,
  alertMessageContent: PropTypes.any,
  onInputKeyPressed: PropTypes.func,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
};

PasswordShowHide.defaultProps = {
  labelHeader: '',
  required: false,
  alertMessageContent: '',
  placeholder: '',
  value: '',
  disabled: false,
  onChange: () => {},
  onInputKeyPressed: () => {},
};

export default PasswordShowHide;
